import React from "react";
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import moment from 'moment';
import { toast } from 'react-toastify';
import './ChangeLog.css';

function ChangeLogList(props) {
    function fieldChangeDetailText(change) {
        return `${change.path}\n---------\n${change.after}`;
    }

    function fieldLabel(change) {
        let parts = change.path.split('/');
        switch (parts[1]) {
            case "prices":
            case "costs":
            case "powertrain":
            case "description":
            case "technicalSpecifications":
            case "bodyDescription":
            case "availability":
            case "carfaxData":
                return parts[2];
            case "tags":
                return parts[1] + ": " + parts[2];
            case "bookOuts":
                return parts[2] + ": " + parts[3];
            default:
                return parts[1];
        }
    }

    if (props.changeLog) {
        return <div>
            <button className="copy-json-button" onClick={() => {copyJSON(props.changeLog)}}><img src="app-json-icon.png" alt="Copy" />Copy</button>
            <Table className="changelog">
            <thead>
                <tr>
                    <th>Client</th>
                    <th>Resource</th>
                    <th>Ver</th>
                    <th>Time</th>
                    <th>Fields</th>
                </tr>
            </thead>
            <tbody>
            {props.changeLog.map((x) => <tr key={x.id}>
                <td style={{whiteSpace: "nowrap"}}>{x.context.clientName ?? x.context.clientId}</td>
                <td style={{whiteSpace: "nowrap"}}>{x.resourceName}</td>
                <td style={{whiteSpace: "nowrap"}}>{x.resourceVersion}</td>
                <td style={{whiteSpace: "nowrap"}} title={x.activityDate}>{moment(x.activityDate).fromNow()}</td>
                <td style={{whitespace: "wrap"}}>
                    {x.changes.slice(0, 10).map((y,i) => <span key={i} className="changelog-field" title={fieldChangeDetailText(y)} onClick={() => {props.onPathSelected(y.path)}}>{fieldLabel(y)}</span>)}
                    {x.changes.length > 10 && <span className="changelog-field-more">+{x.changes.length-10} more</span>}
                    {x.changes.length > 10 && x.changes.slice(10).map((y,i) => <span key={i} className="changelog-field-overflow" title={fieldChangeDetailText(y)} onClick={() => {props.onPathSelected(y.path)}}>{fieldLabel(y)}</span>)}
                    </td>                    
                </tr>)}
            </tbody>
        </Table></div>
    }
    return <Spinner animation="border" />;
}

const copyJSON = (obj) => {
    let jsonString = JSON.stringify(obj, null, 2);
    navigator.clipboard.writeText(jsonString);
    toast.info("JSON copied to clipboard", { autoClose: 1000 });
}

function ChangeLogFiltered(props) {    
    let filterPath = props.filterPath;

    let filteredLogs = props.changeLog.map((x) => {
        let filteredChanges = x.changes.filter((y) => y.path === filterPath);
        if (filteredChanges.length > 0)
            return {...x, changes: filteredChanges};
        else
            return null;
    }).filter(x => x != null)

    function renderValue(val) {
        if (val) {
            if (typeof val === "object")
                return JSON.stringify(val);
            else
                return val.toString();
        }
        else
            return "{null}";
    }

    return <div>
        <button className="copy-json-button" onClick={() => {copyJSON(filteredLogs)}}><img src="app-json-icon.png" alt="Copy" />Copy</button>
        <Table className="changelog">
            <thead>
                <tr>
                    <th>Client</th>
                    <th>Resource</th>
                    <th>Ver</th>
                    <th>Time</th>
                    <th>Value</th>
                </tr>
            </thead>
            <tbody>
            {filteredLogs.map((x) => <tr key={x.id}>
                <td style={{whiteSpace: "nowrap"}}>{x.context.clientId}</td>
                <td style={{whiteSpace: "nowrap"}}>{x.resourceName}</td>
                <td style={{whiteSpace: "nowrap"}}>{x.resourceVersion}</td>
                <td style={{whiteSpace: "nowrap"}}>{moment(x.activityDate).format('YYYY-MM-DD [@] HH:mm')}</td>
                <td style={{whitespace: "wrap"}}>{renderValue(x.changes[0].after)}</td>                    
                </tr>)}
            </tbody>
        </Table></div>
}

function ChangeLogSummary(props) {
    if (!props.changeLog)
        return <div/>
    
    function oldest(changelog) {
        return changelog.reduce((a, b) => a.activityDate < b.activityDate ? a : b);
    }

    function _extractDistinctFields(changeLog) {
        let fields = {};
        changeLog.forEach((x) => {
            x.changes.forEach((y) => {
                let field = y.path;
                if (fields[field])
                    fields[field] ++;
                else
                    fields[field] = 1;
            });
        });
        fields = Object.keys(fields).map(x => {return {path: x, count: fields[x]}});
        fields.sort((a, b) => {
            if (a.count === b.count)
                return a.path - b.path;
            else
                return b.count - a.count;
        });

        return fields;
    }
    let fields = _extractDistinctFields(props.changeLog);

    function handleChange(event) {
        let val = event.target.value;
        if (val === "")
            val = null;
        props.onPathSelected(val);
    }

    return <div className="changelog-summary">
        {props.changeLog.length} total changes, oldest is {props.changeLog.length > 0 ? moment(oldest(props.changeLog).activityDate).fromNow() : "N/A"}
        &nbsp;-&nbsp;<select value={props.selectedPath ?? ""} onChange={handleChange}>
            <option value="">All {fields.length} Fields</option>
            {fields.map((x) => <option key={x.path}
            value={x.path} 
            onChange={props.onPathSelected}>
                {x.path} ({x.count})
                </option>)}
        </select>
        {props.selectedPath && <button onClick={() => {props.onPathSelected(null)}}>X</button>}
    </div>
}


function ChangeLog2(props) {
    const [filter, setFilter] = React.useState(null);

    return <div>
        <ChangeLogSummary changeLog={props.changeLog} selectedPath={filter} onPathSelected={(path) => setFilter(path)} />
        {filter && <ChangeLogFiltered changeLog={props.changeLog} filterPath={filter} />}
        {!filter && <ChangeLogList changeLog={props.changeLog} onPathSelected={(path) => setFilter(path)} />}
        </div>;
}


export default ChangeLog2;